import dayjs from "dayjs";

export function escapingDateTime(date = Date.now(), format = "DD/MM/YYYY") {
  return dayjs(date).format(format);
}

export function macroTokensDateTime(date = Date.now()) {
  return dayjs(date).format("ddd, DD/MM/YYYY, h:mm:ss A");
}

export function countdownTimer({
  due_date,
  status,
  availableAndForthcomingCustom = "rgba(243,249,167,1)",
}) {
  // note: declare
  let remaining;
  remaining = due_date - Date.now(); // note: rest date

  if (remaining > 0) {
    const parts = {
      days: Math.floor(remaining / (1000 * 60 * 60 * 24)),
      // hours: Math.floor((remaining / (1000 * 60 * 60)) % 24),
      // minutes: Math.floor((remaining / 1000 / 60) % 60),
      // seconds: Math.floor((remaining / 1000) % 60),
    };

    // note: return object
    return {
      time: `Due ${Object.keys(parts)
        ?.map((part) => {
          return `${parts[part]} ${part}`;
        })
        ?.join(" ")}`,
      color:
        status === "COMPLETED"
          ? "rgba(56,239,125,1)"
          : availableAndForthcomingCustom,
    };
  }

  remaining = Date.now() - due_date; // note: over date

  const parts = {
    days: Math.floor(remaining / (1000 * 60 * 60 * 24)),
    // hours: Math.floor((remaining / (1000 * 60 * 60)) % 24),
    // minutes: Math.floor((remaining / 1000 / 60) % 60),
    // seconds: Math.floor((remaining / 1000) % 60),
  };

  // note: return object
  return {
    time: `Pass due ${Object?.keys(parts)
      ?.map((part) => {
        return `${parts[part]} ${part}`;
      })
      ?.join(" ")}`,
    color:
      status === "COMPLETED" ? "rgba(56,239,125,1)" : "rgba(255,117,140,1)",
  };
}

export function countDueDateTime({ time }) {
  const parts = {
    minutes: Math.floor((time / 1000 / 60) % 60),
  };

  return Object.keys(parts).map((part) => `${parts[part]} ${part}`);
}

export function builtYear() {
  return new Date("July, 15, 2024").getFullYear() <=
    new Date(Date.now()).getFullYear()
    ? new Date("July,20,2024").getFullYear()
    : `${new Date("July,20,2024").getFullYear()} - ${new Date(
        Date.now()
      ).getFullYear()}`;
}

export function endDate({ date }) {
  date.setHours(23);
  date.setMinutes(59);
  date.setSeconds(59);
  date.setMilliseconds(999);

  return date.getTime();
}

export function formatDate(timestamp) {
  const date = new Date(timestamp);
  const options = {
    year: "numeric",
    month: "long",
    day: "numeric",
  };
  return date.toLocaleDateString("id-ID", options);
}
